export const et = {
  ADD_COLOR_STRING_KEY: 'Add color',
  ADD_TEXT_KEY: 'Lisa teksti',
  ADD_TO_ORDER_KEY: 'Add to order',
  ADD_TO_CART: 'Lisa ostukorvi',
  ADD_TEMPLATE: 'Lisa mall',
  ADJUST_SIZE_KEY: 'Reguleeri suurust',
  ADJUST_TRANSPARENCY_KEY: 'Adjust Transparency',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    "By clicking Done, you agree to the HP's terms of use and privacy statement.",
  ALIGN_BOTTOM_KEY: 'joondage alumine',
  ALIGN_CENTER_KEY: 'joondage keskus',
  ALIGN_KEY: 'joondage',
  ALIGN_LEFT_KEY: 'Align Left',
  ALIGN_MIDDLE_KEY: 'joondage keskel',
  ALIGN_RIGHT_KEY: 'Align Right',
  ALIGN_TOP_KEY: 'Joondage top',
  ALL_TAB_TITLE_KEY: 'All',
  ALMOST_DONE_TITLE_KEY: 'Almost done!',
  AND_KEY: 'and',
  APPLY_KEY: 'Apply',
  AREA_CODE: 'Area code',
  BASIC_HELPER_INSTRUCTION1_KEY:
    'Sirvige sisu ning valige oma disaini jaoks pildid või laadige üles enda omad',
  BASIC_HELPER_INSTRUCTION2_KEY:
    'Vaadake oma disaini eelvaadet või peenhäälestage detaile',
  BASIC_HELPER_INSTRUCTION3_KEY:
    'Kohandage disaini ning lisage oma projektile teisi elemente',
  BASIC_HELPER_INSTRUCTION4_KEY:
    'Kui disain on valmis, siis klõpsake viimaseks ülevaatuseks ning tellimuse esitamiseks EDASI.',
  BACK_KEY: 'Tagasi',
  BACKGROUND_KEY: 'Taust',
  BACKGROUND_UPPER_CASE_KEY: 'BACKGROUND',
  BACKGROUND_CONTRAST_KEY: 'Background Contrast',
  BLANK_INSPIRATION_CATEGORY_KEY: 'Selles kategoorias ei leitud inspiratsiooni',
  BRING_TO_FRONT_KEY: 'Too ette',
  CANCEL_TEXT_KEY: ' Tühista ',
  CENTIMETERS_KEY: 'sentimeetrit',
  CM_KEY: 'cm',
  CHANGE_YOUR_SETTINGS_KEY: 'Change your project settings',
  CHECKBOX_CONTENT1: 'I want to receive the Pattern Design© newsletter',
  CHECKBOX_CONTENT2:
    'I authorize HP to create an account in Pattern Design© services on my behalf',
  CHOOSE_FROM_COMPUTER_KEY: 'Choose from computer',
  CHOOSE_RIP_OPTIONS: 'Choose one of these compatible third party RIPs',
  CHOOSE_FILE_KEY: 'Vali fail',
  CITY: 'City',
  CLEAR_ALL_KEY: 'Tühjenda kõik',
  CLEAR_COLOR_KEY: 'Tühjenda värv',
  CLOSE_WINDOW_KEY: 'Sule aken',
  CLEAR_ALL_OBJECTS: 'Tühjenda kõik objektid',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE: 'See eemaldab kõik objektid taustalt.',
  CLEAR_DESIGN_KEY: 'Clear design',
  COLOR_KEY: 'Värv',
  CONTINUE_KEY: 'Jätka...',
  COMPANY: 'Company',
  CONGRATULATIONS_KEY: 'Congratulations!',
  CONFIRM_PASSWORD: 'Confirm password',
  CONFIRM_PATTERN_ACCOUNT_KEY: "Don't have a Pattern Design account yet?",
  CONFIRM_VECTEEZY_ACCOUNT_KEY: "Don't have a Vecteezy account yet?",
  COUNTRY: 'Country',
  CREATE_ACCOUNT: 'Create account',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: 'Kohandatud',
  CUSTOM_PRICE_SIGN_IN_KEY: 'Sign-in in the next step to see custom pricing.',
  CM_UNIT_KEY: 'cm',
  CREATE_NEW: 'Create new',
  DESIGN_KEY: 'Disainiprogramm',
  DELETE_KEY: 'Kustuta',
  DOCUMENT_COLORS: 'Dokumendi värvid',
  DONE: 'Done!',
  DONE_KEY: 'Valmis',
  DONT_SHOW_ALERT_KEY: "Don't show again",
  DOWNLOAD_COLUMN_HEADER_KEY: 'Laadi alla',
  DOWNLOAD_APP_TITLE_KEY: 'Saate laadida rakenduse alla siit:',
  DOWNLOAD_LINK_KEY: 'Download HP Click for free here',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DOWNLOAD_INSTR_KEY: 'Make sure you have HP Click installed before continuing',
  DOWNLOAD_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Importimine Dropboxist',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    'The image size should be less than 1 GB. We accept pdf, png, jpg, svg and tiff formats.',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Dreamstime otsing',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: "Dreamstime'i pildid",
  DUPLICATE_KEY: 'Dubleeri',
  EACH_ITEM_PRICE_KEY:
    'Your design includes content from one of our premium content providers. The itemized pricing of each element is summarized below.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'Muuda disainitööd',
  EDIT_LOWERCASE_KEY: 'muuda',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT:
    'Kahjuks tekkis tõrge. Palun proovige hiljem uuesti.',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    'Kahjuks tekkis üleslaaditud PDF-faili avamisel tõrge.',
  EMAIL_KEY: 'E-posti aadress',
  EMAIL_ADDRESS_KEY: 'E-posti aadress:',
  EMAIL_CHECKBOX_MESSAGE:
    'Ma tean, et see isik mõistab, et talle saadetakse e-kirju HP-lt, mis on algatatud minu või selle teenusepakkuja poolt. ',
  EXTRA_INFO_KEY: 'Lisateave',
  EMAIL_NOTIFICATION:
    'Kohe varsti saadetakse teile e-kiri. Meil kulub töötlemiseks umbes 15 minutit.',
  EMAIL_DIALOG_MESSAGE:
    'Sisestage e-posti aadress, kellega soovite oma disainitööd jagada.',
  ENTER_KEY: 'Enter',
  EXISTING_FOLDER_KEY: 'Olemasolev kaust',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'Enne maksmise juurde liikumist veenduge, et kõik valitud tooted oleks õiged',
  FINAL_CHECK_TITLE_KEY: 'Lõplik kontroll',
  FINISH_KEY: 'Lõpeta',
  FINISH_LATER_KEY: 'Finish later',
  FIRSTNAME: 'First name',
  FISCAL_NUM: 'Fiscal number',
  FLIP_KEY: 'Pööra ümber',
  FOR_KEY: 'jaoks',
  FORGOT_PASSWORD_KEY: 'Forgot password?',
  FOTOLIA_KEYWORDS_KEY: 'Märksõnad:',
  FOLDER_NAME: 'Kausta nimi',
  FOLDER_NAME_KEY: 'Kausta nimi:',
  FOLDER_ALREADY_EXIST_KEY: 'See kaustanimi on juba olemas',
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    "You've just completed your free poster design",
  FREE_VECTOR_GRAPHICS_KEY: 'free vector graphics',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: 'OK, sain aru',
  GROUP_ALL_KEY: 'Grupeeri kõik',
  GROUP_SCALE: 'Grupiskaleerimine',
  GIFT_WRAPS_KEY: 'Gift Wraps',
  GIVE_PROJECT_NAME_KEY: 'Andke oma projektile nimi',
  HEIGHT_KEY: 'Kõrgus',
  HELP_DESCRIPTION_KEY:
    'Juhatame teid läbi disainiprotsessi. Ärge unustage, et saate avada seda tutvustust nii mitu korda kui soovite, kui klõpsate abiikoonil.',
  HELP_KEY: 'Abi',
  HELPER_TITLE_KEY_1:
    'Create poster designs from a blank page or from millions of images and text. Upload your own content from local drives, Dropbox or social media',
  HELPER_TITLE_KEY_3: 'See all your design work in one place',
  HELPER_TITLE_KEY_4: 'Click Next to preview and finish your final design',
  HERE_KEY: 'here',
  HELP_IMPROVE_KEY:
    'Help improve your productivity and operator efficiency, and expand with color production.',
  HIGH_QUALITY_KEY: 'High-quality',
  IMAGES_TITLE_KEY: 'PILDID',
  IMPERIAL_KEY: 'Imperial',
  IMPORTING_KEY: 'Importimine',
  INCHES_COLUMN_HEADER_KEY: 'Tollid',
  INCHES_KEY: ' tolli',
  INCHES_UNIT_STRING_KEY: 'tolli',
  INVALID_EMAIL_ADDRESS_KEY: 'Sobimatu e-posti aadress',
  INVALID_INFO_KEY: 'Please enter details.',
  INVALID_NAME_KEY: 'Sobimatu nimi',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    'Kahjuks on teie poolt valitud fail liiga suur. Faili maksimaalne maht on 500 MB.',
  INSUFFICIENT_CREDITS_KEY: 'Insufficient credits',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Inspiration',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    'Kahjuks pole see kehtiv failivorming. Suudame kasutada ainult pdf-, jpg-, png- ja tif-vorminguid.',
  LANDSCAPE_KEY: 'Landscape',
  LANGUAGE_LABLE_KEY: 'Keel',
  LASTNAME: 'Last name',
  LEARN_MORE: 'Lisateave',
  LEARN_THE_BASICS_KEY: 'Õppige põhiasjad selgeks',
  LEGAL_FOOTER_MESSAGE1_KEY:
    'Kasutades seda saiti nõustute siduma ennast järgmisega:',
  LEGAL_FOOTER_MESSAGE2_KEY: 'See veebisait vastab järgmisele:',
  LEGAL_FOOTER_MESSAGE3_KEY: 'ja',
  LENGTH_STRING_IN_INCHES_KEY: 'tolli',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: 'change',
  LINK_READER_APP_KEY: 'LinkReader App',
  LINK_READER_APP_DESCRIPTION_KEY:
    'Lisatava sisu visualiseerimiseks laadige palun alla rakendus LinkReader.',
  LOADING_KEY: 'Laadimine...',
  LOADING_TEMPLATE_KEY: 'Loading template',
  LOGIN_NOW: 'Login now',
  LOCK_KEY: 'Lukusta',
  LOGIN_KEY: 'Sisselogimine',
  LOGIN_PATTERN_DESIGN_KEY: 'Login to Pattern design',
  LOGIN_SUBTITLE_KEY: 'Login to see customized pricing and payment details',
  LOGIN_VECTEEZY_KEY: 'Login to Vecteezy',
  LOGIN_DREAMSTIME_KEY: "Logi sisse Dreamstime'i ",
  LOGOUT_KEY: 'Logi välja',
  MATERIAL_TITLE_KEY: 'MATERJAL',
  MATERIAL_STRING_KEY: 'Materjal',
  MEASUREMENT_KEY: 'Measurement',
  METRIC_KEY: 'Metric',
  MINIMUM_ZOOM_WARNING:
    'Seda tausta ei saa rohkem väiksemaks skaleerida, sest olete jõudnud minimaalse kõrguseni või laiuseni, mis on vajalik seina katmiseks.',
  MOBILE: 'Mobile',
  MODEL_TITLE_KEY: 'Mudel',
  MORE_INFO_TEXT_KEY: 'Lisateave',
  MY_GIFTWRAPS_KEY: 'My Gift Wraps',
  MY_WORK_KEY: 'My work',
  MY_WORK_SAVE_KEY: 'Your design has been saved to your My Work space',
  NAME_KEY: 'Nimi:',
  NEXT_BUTTON_TITLE_KEY: 'JÄRGMINE',
  NEW_FOLDER_KEY: 'Uus kaust',
  NO_SHADOW_KEY: 'Varjuta',
  OBJECT_QUANTITY_KEY: 'Quantity',
  OBJECTS_UPPER_CASE_KEY: 'OBJECTS',
  OK_KEY: 'OK',
  ORDER_SAMPLE_KEY: 'Tellimuse näidis',
  ORDER_SAMPLE: 'Tellige näidis',
  ORDER_SAMPLE_INFOLABEL_1:
    'Valige pildi osa, mille kohta soovite tellida näidise',
  ORDER_SAMPLE_INFOLABEL_2:
    'Teile saadetakse e-kiri koos lähivaatega teie projektist tegelikuses suuruses',
  ORDER_SAMPLE_INFOLABEL_3:
    'See aitab teil hinnata selle kvaliteeti ja lahutust',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: 'Tellige näidis kohe',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    'Teile saadetakse e-kiri, kus on lähivaade teie projektist tegelikus suuruses, et saaksite hinnata selle kvaliteeti/lahutust.',
  ORIENTATION_KEY: 'Orientation',
  OTHER_PRINTING_OPTIONS: 'Other printing options',
  PASSWORD_KEY: 'Parool',
  PATTERN_COLOR_KEY: 'Pattern Color',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design',
  PATTERNS_FOR_KEY: 'patterns for',
  PDF_GENERATION_ERROR_MESSAGE_KEY: 'Failed to generate pdf. Please try again.',
  PHOTOS_KEY: 'PHOTOS',
  PHOTO: 'photo',
  PHONE: 'Phone',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    'Mulle kuuluvad selle pildi autoriõigused ning nõustun',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    'The image size should be less than 500 MB. We accept png, jpg, tiff, svg and pdf formats.',
  PIXEL_COLUMN_HEADER_KEY: 'Pikslid',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'cm',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Enter text here...',
  PLACEHOLDER_EXTRA_INFO_KEY:
    's.t peate osasid olulisi asju arutama prinditeenuse pakkujaga',
  PLACEHOLDER_INCHES_STRING_KEY: 'tolli',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'My Poster',
  PORTRAIT_KEY: 'Portrait',
  POSITION: 'Asukoht',
  PREMIUM_IMAGES_TITLE_KEY: 'Premium images:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'Salvestage oma projekt',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    'Teie projektil on muudatusi, mis tuleb enne jätkamist salvestada.',
  PRICE_COLUMN_HEADER_KEY: 'Hind',
  PRINTER_SERIAL_NUMBER_KEY: 'Printer serial number*',
  PRINTING_ENABLE_DETAILS_KEY:
    'To enable printing we just need a few more details',
  PRINTER_MODELS_KEY: 'Printer models*',
  PROCESSING_KEY: 'Töötlemine...',
  PROCESSING_ALERT_TXT:
    'Do not close this window while we are processing your design',
  PROCESSING_ALERT_TXT2:
    'Once processing has been completed, HP Click will open automatically and start downloading your file',
  PROCESSING_DONE: 'You are almost done!',
  PROCESSING_FILE_TXT: 'Your file is being processed.',
  PROCESSING_TIME_TXT:
    'This may take some time as we are composing your creation to ensure the best image quality',
  PROCESSING_ALERT_TXT3:
    'Your PDF will be automatically downloaded to your computer',
  PROCESSING_ALERT_TXT4:
    'Remember you can configure your JDF connection for automation in settings',
  PREMIUM_CONTENT_KEY: 'Premium Content',
  PREVIEW_KEY: 'Eelvaade',
  PROFESSIONAL_USE_TITLE_KEY: 'professional use.',
  PROJECT_NAME_KEY: 'Projekti nimi',
  PROJECT_NAME: 'Projekti nimi:',
  PROJECT_ALREADY_EXIST_KEY: 'See projektinimi on juba olemas',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'See projektinimi on juba olemas',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'See kaustanimi on juba olemas',
  PIXELATION_WARNING_KEY: 'Pikslilahutuse hoiatus',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    'Teie üleslaaditud foto eraldusvõime tõttu võib teie nahk olla moonutatud või moonutatud. Hägususe vältimiseks laadige üles hea kvaliteediga pilt ja vältige pildi venitamist. Kui olete eelvaatega rahul ja soovite jätkata, jätkake esitamist.',
  REGISTER_CONTACTINFO: 'Contact information',
  REGISTER_INFO: 'Register information',
  REGISTER_PATTERNSUB1: 'As a value HP customer,',
  REQUIRED_FIELDS_KEY: 'Required fields',
  REQUIRED_FIELDS_TEXT_KEY: 'Required fields',
  REQUIRED_STRING_KEY: 'NÕUTAV',
  RECOLOR_KEY: 'Muuda värvi',
  RADICALLY_SIMPLE_KEY: 'Radically simple printing software',
  RIPSELECTION_HEAD:
    'This is your first time, select your prefered compatible printing software',
  RIPSELECTION_DESC:
    'Your selection will become your default printing option path for future print outs. Changes can be made later in settings',
  REGISTER_COMPANYINFO: 'Company information',
  REGISTER_KEY: 'Register',
  REGISTER_NOW: 'Register now',
  REOLOR_KEY: 'Muuda värvi',
  REQUEST_SAMPLE_KEY: 'Taotle näidist',
  RESIZE_KEY: 'Resize',
  RESIZE_ARBITRARILY_KEY: 'Resize Arbitrarily',
  RESIZE_PROPORTIONALLY_KEY: 'Resize Proportionally',
  REVIEW_AND_SUBMIT_KEY: 'Review and Submit',
  REQUEST_FOR_QUOTATION: 'Taotlege hinnapakkumist',
  RIGHT_LOGO_TEXT_KEY: 'autorilt',
  ROTATE_KEY: 'Pööra',
  ROTATE_LEFT_KEY: 'Pööra 90° vasakule',
  ROTATE_RIGHT_KEY: 'Pööra 90° paremale',
  ROTATION_KEY: 'Pööramine',
  ROWS_COLUMN_LABEL_STRING_KEY: 'Read ja veerud',
  ROYALTY_FREE_KEY: 'royalty-free',
  ROYALTY_KEY: 'royalty',
  SALUTATION: 'Salutation',
  SAVE_KEY: 'Salvesta',
  SAVING_KEY: 'Salvestamine...',
  SAVE_INSPIRATION: 'Save inspiration',
  SAVE_TEMPLATE: 'Salvesta mall',
  SAVE_DIALOG_TITLE: 'Salvestage oma projekt',
  SAVE_PROJECT_NAME_KEY: 'Kõigepealt salvestage oma projekt',
  SAVEDIALOG_MESSAGE:
    'Oma projekti salvestamiseks logige sisse. Kui teil pole kontot, siis me aitame teil selle luua. Teie tehtud töö ei lähe kaotsi.',
  SEAMLESS_KEY: 'seamless',
  SCALE_INFO_STRING_KEY: 'Skaleerige pilt oma disaini jaoks sobilikuks',
  SCALE_KEY: 'Skaala',
  SCALE_ALL_KEY: 'Skaleeri kõik',
  SCALE_TO_FILL_KEY: 'Skaleeri täitmiseks',
  SEARCH_BUTTON_TITLE_KEY: 'Otsi',
  SELECT_CUSTOM_SIZE_KEY: 'Valige kohandatud suurus',
  SELECT_CUSTOM_KEY: 'Kohandatud',
  SEARCH_TITLE: 'Otsi',
  SELECTED_IMAGE_KEY: ' Selected Image: ',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Select Gift Wraps size',
  SELECT_COUNTRY: 'Select Country',
  SELECT_SALUTATION: '---Select---',
  SELECT_POSTER_SIZE_KEY: 'Valige plakati suurus',
  SELECT_PRINTING_OPTION_KEY: 'Select your prefered printing option',
  SEND_INSTALLATION_INSTRUCTION_KEY: 'Saada mulle paigaldusjuhised',
  SEND_TO_BACK_KEY: 'Saada taha',
  SEND_KEY: 'Saad',
  SEND_TO_PRINT_TITLE_KEY: 'Send to print',
  SET_SIZE_KEY: 'Määra suurus',
  SETTINGS_KEY: 'Seaded',
  SETTINGS_UPPERCASE_KEY: 'SETTINGS',
  SHARE_KEY: 'Jaga',
  SIGNED_IN_AS_KEY: 'Signed in as',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Sign in or register to see customized pricing and payment details',
  SIGN_UP_NOW_KEY: 'Sign up now',
  SKIP_KEY: 'Skip',
  SOLID_COLORS_KEY: 'Solid Colors',
  SQFT_UNIT_STRING_KEY: 'ruutjalga',
  SQM_UNIT_STRING_KEY: 'm²',
  START_TOUR_KEY: 'Start tour',
  STATUS_MSG: 'Your file has been sent to print!',
  SUBMIT_BUTTON_KEY: 'Esita',
  SHARE_LINK_LABEL: 'Valige jagatava lingi tüüp',
  SHARE_EDIT_LINK: 'Muuda linki',
  SHARE_VIEW_LINK: 'Kuva link',
  SHARE_YOUR_CREATION: 'Share your creation!',
  STREET_ADD: 'Street address',
  TARGET_VIEWING_HINT: '* Vaatamise sihtkaugust saab muuta seadete alt.',
  TERMS1_KEY: 'tingimused',
  TERMS2_KEY: 'HP privaatsusavaldus',
  TERMS3_KEY: 'HP isikuandmete õiguste teatis',
  TERMS_OF_USE_KEY: 'Terms of use',
  TERMS_OF_USE: 'Kasutustingimused',
  TEXT_SHADOW_COLOR_KEY: 'Text shadow Color',
  TEXT_UPPERCASE_KEY: 'TEXT',
  TILE_KEY: 'Paani',
  TOTAL_KEY: 'KOKKU',
  TOTAL_PRICE_KEY: 'Total:',
  TRANSPARENCY_KEY: 'Transparency',
  TEMPLATES_KEY: 'templates',
  TEMPLATES_UPPER_CASE_KEY: 'TEMPLATES',
  THANK_YOU_KEY: 'Aitäh',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: 'Ava lukust',
  UNGROUP_KEY: 'Tühista grupeerimine',
  UPDATE_TEXT_KEY: 'Värskenda',
  UPLOAD_KEY: 'Laadi üles',
  UPLOAD_LOGO_KEY: 'Upload logo',
  UPLOAD_IMAGE_KEY: 'Upload your own image',
  UPLOAD_UPPERCASE_KEY: 'UPLOAD',
  USER_NAME: 'Kasutajanimi',
  USER_TYPE_TITLE_KEY: 'What type of user are you*',
  UNTILE_KEY: 'Tühista paanimine',
  UNSPLASH_SEARCH_TITLE: 'Unsplash Search',
  VALIDITY_KEY: 'Kehtivus',
  VANILLA_LOGIN_DIALOG_KEY:
    'Join for free to save and print your design and see your saved work',
  VANILLA_PREVIEW_MESSAGE_KEY:
    'This is the preview of your design, check the design is final before proceeding or select edit to make any changes',
  VAT_KEY: 'KM',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'vector',
  VIEW_FOTOLIA_KEY: 'Kuva teenuses Fotolia©',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_DESIGN_DETAILS_KEY: 'Kuva disainitöö detailid',
  VIEW_DESIGNER_PROFILE_KEY: 'Kuva disainiprofiil',
  VIEW_PRICE_KEY: 'Kuva hind',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy Search',
  WALL_POSTER_KEY: 'Plakatid',
  WALL_SIZE_TEXT_KEY: 'Seina suurus',
  WARNING_KEY: 'Hoiatus',
  WEBSITE: 'Website',
  WIDTH_KEY: 'Laius',
  YOU_CAN_ALWAYS_ACCESS: 'You can always access your designs in ',
  YOUR_NAME_KEY: 'Teie nimi',
  YOUR_SELECTION_WILL_KEY:
    'Your selection will become your default printing path for future print outs.',
  YOUR_PROJECT_KEY: 'Teie projekt:',
  PROJECT_NAME_ERROR_TEXT: 'Palun sisestage oma projektile nimi.',
  PROJECT_FOLDER_ERROR_TEXT: 'Palun sisestage oma projektikaustale nimi.',
  PIXELATION_WARNING_SETTINGS_KEY: 'Pixel warning settings',
  MINIMUM_VIEWING_DISTANCE_KEY: 'Minimaalne vaatekaugus',
  BACKGROUND_UPLOAD_KEY: ' background ',
  OBJECT_UPLOAD_KEY: ' object ',
  PHOTO_UPLOAD_KEY: ' photo ',
  NO_DREAMSTIME_ERROR_MESSAGE: 'Unenäoaja puudumine Leitud sisu',
  NO_ELEMENT_ERROR_MESSAGE: 'Üksusi ei leitud.',
  NO_MORE_IMAGES_FOUND_KEY: 'Rohkem pilte ei leitud',
  NO_PATTERN_ERROR_MESSAGE: 'Mustreid ei leitud',
  TEXT_ANCHOR_MIDDLE: 'Center',
  TOUR_DESCRIPTION_TEXT:
    'Let us walk you through the design process. Remember you can re-open the tour at any time by clicking on the help icon.',

  ALREDY_HAVE_AN_ACCOUNT: 'Already have a {0} account?',
  CHANGE_MEASURING_SYSTEM_KEY: 'Change to {0}',
  DOWNLOADS_KEY: '{0} downloads',
  HEX_COLOR_KEY: 'Hex color: {0}',
  NEAR_KEY: 'Near',
  FAR_KEY: 'Far',
  CLOSE_UP_KEY: 'Close Up',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    'The images you are trying to use are either smaller or larger than the design area you are using.',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'To get better results use a {0} X {1} resolution image',
  MESSAGE_KEY: 'Sõnum',
  VIEWS_KEY: '{0} views',
  COST_DESCRIPTION_MESSAGE_KEY:
    'This is the summary of the cost related to the premium content included in your design. {0} By selecting finish you agree to be charged the following cost by the content providers.',
  DEFAULT_PRINTING_OPTION_KEY: '{0} is your default printing option,',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    ' you will revieve $100 worth of high-resolution images {0} to help with all your creative needs!',
  REGISTER_PATTERNSUB3:
    'Sign up today and over the course of the next 30 days, download creative files from our content base of 25 million photos, and see how {0} can help you meet your creative needs.',
  ZOOM_WARNING_PIXELATED_TEXT:
    'Olete skaleerinud punktini, kus teie prinditud pilt võib paista pikseldatuna, kui vaatate seda {0} {1} kauguselt * (praegune prindilahutus on {2} dpi).',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    'Soovituslik vaatamiskaugus oleks {0} {1}. Kui see ei sobi, siis palun vähendage selle pildi skaalat või seina suurust.',
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    'Soovituslik pildi miinimumsuurus on {0} x {1} pikslit.',
  UPLOAD_STATUS: '{0}% of {1}MB',
  REGISTER_TO: 'Register to {0}',
  MINIMUM_DIMENSIONS_KEY: 'Minimaalsed mõõtmed on {0} (laius) x {1} (kõrgus).',
  MINIMUM_HEIGHT_KEY: 'Miinimumkõrgus on {0}.',
  MINIMUM_WIDTH_KEY: 'Miinimumlaius on {0}.',
  MAXIMUM_DIMENSIONS_KEY: 'Maksimaalsed mõõtmed on {0} (laius) x {1} (kõrgus).',
  MAXIMUM_WIDTH_KEY: 'Maksimaalne laius on {0}.',
  MAXIMUM_HEIGHT_KEY: 'Maksimaalne kõrgus on {0}',
  INVALID_NUMBER_ERROR_TEXT_KEY:
    'Palun sisestage numbrilised mõõtmed, mis on nullist suuremad.',
  PROCESSING_FAILED:
    'Töötlemine ebaõnnestus, palun proovige mõne aja pärast uuesti',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT:
    'Kahjuks ei toetata krüpteeritud PDF-faile.',
  DROPBOX_UPLOAD_PROGRESS_KEY: 'Faili importimine {0} of {1}',
  RECOLORING_KEY: 'Värvi muutmine...',
  TEXT_COLOR_KEY: 'Text Color',
  SOLID_COLOR_KEY: 'Ühtlane värv',
  AUTHENTICATE_DIALOG_TITLE: 'See sisuallikas on paroolikaitsega',
  AUTHENTICATE_FAILED_MESSAGE: 'Autentimine ebaõnnestus!',
  DROPBOX_IMPORT_ERROR_HEADER: 'Osade failide importimisel tekkis probleem',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT:
    'Kahjuks mitmeleheküljelisi PDF-faile ei toetata.',
  HP_FEEDBACK_TEXT: 'HP wants your feedback',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with our solutions?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/propreitary content",
  DEFAULT_PROJECT_NAME: 'Project',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'Choose your laptop',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'First name',
  LAST_NAME_KEY: 'Last name',
  PHONE_NUMBER_KEY: 'Phone No.',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: 'Invalid phone number',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'I accept the terms and conditions.',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'I accept that my personal information will be shared with HP to be contacted about future HP campaigns. *',
  SERVICE_PROVIDER_CONDITION:
    'I accept that the data I provide may be shared with service providers for the purposes of printing and delivery process.',
  ORDER_DESIGN: 'Order design',
  SUBMIT_YOUR_DESIGN: 'Submit your design',
  SUBMISSION_DESIGN_ORDER: 'Submission for design order',
  ENTER_REQUIRED_FIELDS_KEY: 'Sisestage kohustuslikud väljad',
  ADDRESS_KEY: 'Address',
  INVALID_ADDRESS_KEY: 'Invalid address',
  CITY_KEY: 'City',
  INVALID_CITY_KEY: 'Invalid city',
  COUNTRY_KEY: 'Country',
  STATE_KEY: 'State',
  ZIP_KEY: 'Zip',
  INVALID_ZIP_KEY: 'Invalid zip code',
  ORDER_NUMBER: 'Order number',
  YOUR_DETAILS_KEY: 'Teie andmed',
  APPLY_DESIGN_COMPETITION: 'Apply for the design competition',
  NOTICE_KEY: 'Teade:',
  CAUTION_FOR_LAPTOP_SELECTION:
    'Teie enda jaoks täiuslikult kohandatud PC-i naha jaoks peate valima ostule vastava täpse mudeli, nagu see on arvel näha.',
  RESTART_PROJECT_ALERT_TITLE: 'Alustada projektiga uuesti?',
  DISCARD_ALERT_MESSAGE: 'Teie praegune projekt hüljatakse',
  RESTART: 'Alusta uuesti',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: 'Lehe suurus Hoiatus!',
  INSPIRATION_SIZE_CHANGE_WARNING:
    'Selle inspiratsioonimalli vaikesuurus on {0} X {1} {2}. Teie lehe suurust muudetakse automaatselt, et see malli sobiks.',
  MODIFY_SIZE_WARNING:
    'Kui soovite selle kujunduse suurust muuta, saate seda teha vahekaardil „Seaded”. Kujunduselementide soovitud mõõtmete kohandamiseks võib vajada muutmist.',
  RANDOMIZE_KEY: 'Juhuslikult',
  MATERIAL_CHOICE_APPLIED: 'Materjalivalik kohaldatud.',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  BLOCKCHAIN_STRING: 'Blockchain',
  CERTIFICATE_STRING: 'sertifikaat',
  AUTHENTICITY_STRING: 'autentsus',
  PLEASE_WAIT: 'Palun oota',
  PROTECTING_YOUR_DATA: 'teie andmete kaitsmine...',
  SEARCH_YOUR_LAPTOP_KEY: 'Otsige oma sülearvuti', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    'Vabandust! Me ei leidnud teie otsingule sülearvuteid.', // Google translated

  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  SERIAL_NUMBER_KEY: 'Seerianumber',
  LOCKED_PROJECT: 'Lukustatud projekt.',
  LOCKED_MESSAGE:
    'Teie projekti tellimus on juba esitatud ja seda ei saa muuta. Saate vaadata ainult seda projekti. ',
  EXPIRED_PROJECT: 'Aegunud projekt',
  EXPIRED_MESSAGE: 'See projekt on aegunud',
  DELETED_PROJECT: 'Kustutatud projekt',
  DELETED_MESSAGE: 'See projekt on kustutatud',
  CHOOSE_GROUP_TYPE: 'Valige {0} tüüp',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'Palun sisestage nullist suuremad numbrid.',
  SIZE_KEY: 'Suurus',
  DISTANCE_FROM_KEY: 'Kaugus:',
  MYROOM_UPPERCASE_KEY: 'MY ROOM',
  FURNITURE_KEY: 'Mööbel',
  FIXTURES_KEY: 'Püsiinventar',
  ADD_A_WALL_KEY: 'Add a wall',
  SELECT_A_WALL_KEY: 'Select a Wall',
  LEFT_KEY: 'Vasakul',
  RIGHT_KEY: 'Paremal',
  DELETE_WALL_KEY: 'Kustuta sein',
  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: 'Valige lõuendi tüüp',
  MAXIMUM_WALL_SIZE_KEY: 'Maksimaalne seina suurus on {0} sq. {1}.',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY: 'Lõuend on kõrgem kui sein.',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY: 'Lõuend on laiem kui sein.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY:
    'Praeguse laiusega on maksimaalne veergude arv {0}',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY:
    'Praeguse kõrgusega on maksimaalne ridade arv {0}',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    'eina laius on väiksem kui lõuendi laius.',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY: 'Seina miinimulaius on {0} {1}.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY: 'Seina miinimukõrgus on {0} {1}.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    'Seina kõrgus on väiksem kui lõuendi kõrgus.',
  MAXIMUM_WALL_HEIGHT_KEY: 'Maksimaalne seina kõrgus on {0} {1}.',
  FINISHING_KEY: 'Viimistlus',
  MIRROR_KEY: 'Peegel',
  NATURAL_KEY: 'Naturaalne',
  ROWS_KEY: 'Read',
  COLUMNS_KEY: 'Veerud',
  DEFAULT_WALL_SIZE_KEY: 'Seina vaikesuurus',
  EDIT_KEY: 'Muuda',
  TOP_KEY: 'Üleval',
  BOTTOM_KEY: 'Alt'
};
